import { configureStore } from '@reduxjs/toolkit';
import { onboardingSlice } from './slices/onboarding/onboardingSlice';
import { physicianSlice } from './slices/physician/physicianSlice';
import { sharedSlice } from './slices/shared/sharedSlice';
import { authSlice } from './slices/auth/authSlice';
import { authApiSlice } from './slices/auth/authThunk';
import { physicianApiSlice } from './slices/physician/physicianThunk';

const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        onboarding: onboardingSlice.reducer,
        physician: physicianSlice.reducer,
        shared: sharedSlice.reducer,
        [authApiSlice.reducerPath]: authApiSlice.reducer,
        [physicianApiSlice.reducerPath]: physicianApiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware()
            .concat(authApiSlice.middleware)
            .concat(physicianApiSlice.middleware),
});

export default store;
